import AOS from 'aos/dist/aos.js';

export default {
  init() {
    AOS.init({
      once: true,
    });

    $(document).on('click', '.faq-popup-3 .next', function (event) {
      event.preventDefault();
      $('.faq-popup-3 .opened').removeClass('opened');
      $('.faq-popup-3 .step-2').addClass('opened');
      $('.faq-popup-3 .content-2').addClass('opened');
      $('.faq-popup-3 .next').addClass('hidden');
      $('.faq-popup-3 .prev').removeClass('hidden');
      $('.faq-popup-3 .done').removeClass('hidden');
    });

    $(document).on('click', '.faq-popup-3 .prev', function (event) {
      event.preventDefault();
      $('.faq-popup-3 .opened').removeClass('opened');
      $('.faq-popup-3 .step-1').addClass('opened');
      $('.faq-popup-3 .content-1').addClass('opened');
      $('.faq-popup-3 .prev').addClass('hidden');
      $('.faq-popup-3 .next').removeClass('hidden');
      $('.faq-popup-3 .done').addClass('hidden');
    });

    $(document).on('click', '.faq-popup-4 .next', function (event) {
      let slide = $('.faq-popup-4').data('slide') + 1;
      $('.faq-popup-4').data('slide', slide);
      event.preventDefault();
      $('.faq-popup-4 .opened').removeClass('opened');
      $('.faq-popup-4 .step-' + slide).addClass('opened');
      $('.faq-popup-4 .content-' + slide).addClass('opened');
      if(slide == 4) {
        $('.faq-popup-4 .next').addClass('hidden');
        $('.faq-popup-4 .done').removeClass('hidden');
      }
      $('.faq-popup-4 .prev').removeClass('hidden');
    });

    $(document).on('click', '.faq-popup-4 .prev', function (event) {
      let slide = $('.faq-popup-4').data('slide') - 1;
      $('.faq-popup-4').data('slide', slide);
      event.preventDefault();
      $('.faq-popup-4 .opened').removeClass('opened');
      $('.faq-popup-4 .step-' + slide).addClass('opened');
      $('.faq-popup-4 .content-' + slide).addClass('opened');
      $('.faq-popup-4 .next').removeClass('hidden');
      $('.faq-popup-4 .done').addClass('hidden');
      if(slide == 1) $('.faq-popup-4 .prev').addClass('hidden');
    });

    $(document).on('click', '.done', function () {
      $.magnificPopup.close()
    });

    $('.open-popup-link').magnificPopup({
      type:'inline',
      midClick: true,
      callbacks: {
        open: function() {
          $('body, html').addClass('prevent-scroll');
        },
        close: function() {
          $('body, html').removeClass('prevent-scroll');
        },
      },
    });

    $('.open-popup-link-wrap a').magnificPopup({
      type:'inline',
      midClick: true,
      callbacks: {
        open: function() {
          $('body, html').addClass('prevent-scroll');
        },
        close: function() {
          $('body, html').removeClass('prevent-scroll');
        },
      },
    });

    $('.ministry-container').mCustomScrollbar();

    $('.scrolled').mCustomScrollbar();

    var distance = 50;

    $(window).scroll(function() {
        if($(this).scrollTop() >= distance ) {
            $('.banner').addClass('scrolled');
        } else {
            $('.banner').removeClass('scrolled');
        }
    });

    $(document).on('click', 'a[href^="#"].down-arrow', function (event) {
      event.preventDefault();
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - $('.header-bar-container').height(),
      }, 500);
    });

    // $(document).on('click', 'a[href^="#"].go-fund-them-click', function (event) {
    //   event.preventDefault();
    //   $('html, body').animate({
    //       scrollTop: $($.attr(this, 'href')).offset().top - $('.header-bar-container').height(),
    //   }, 500);
    // });

    $(document).on('click', '.last', function () {
      $('.last input').not(':checked').prop('checked', true);
    });

    $(document).on('click', '.first', function () {
      $('.first input').not(':checked').prop('checked', true);
    });

    $('.group1').click(function(e) {
      e.preventDefault();
      $('.jesus-said-slider').slick('slickGoTo', 0);
      $('html, body').animate({
        scrollTop: $('.jesus-said').offset().top - $('.header-bar-container').height(),
      }, 500);
    });

    $('.group2').click(function(e) {
      e.preventDefault();
      $('.jesus-said-slider').slick('slickGoTo', 1);
      $('html, body').animate({
        scrollTop: $('.jesus-said').offset().top - $('.header-bar-container').height(),
      }, 500);
    });

    $('.group3').click(function(e) {
      e.preventDefault();
      $('.jesus-said-slider').slick('slickGoTo', 2);
      $('html, body').animate({
        scrollTop: $('.jesus-said').offset().top - $('.header-bar-container').height(),
      }, 500);
    });

    $('.group4').click(function(e) {
      e.preventDefault();
      $('.jesus-said-slider').slick('slickGoTo', 3);
      $('html, body').animate({
        scrollTop: $('.jesus-said').offset().top - $('.header-bar-container').height(),
      }, 500);
    });

    $('.group5').click(function(e) {
      e.preventDefault();
      $('.jesus-said-slider').slick('slickGoTo', 4);
      $('html, body').animate({
        scrollTop: $('.jesus-said').offset().top - $('.header-bar-container').height(),
      }, 500);
    });

    $('.value-container').slick({
      dots: true,
      slidesToShow: 1,
      arrows: false,
      adaptiveHeight: true,
      fade: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 4000,
    });

    $('.jesus-said-slider').slick({
      dots: false,
      slidesToShow: 1,
      arrows: true,
      prevArrow: $('.left'),
      nextArrow: $('.right'),
      centerMode: true,
      fade: true,
      infinite: true,
    });

    $('.popup-nav-link').click(function(){
      $('.popout-nav-container').addClass('open')
    });

    $('.close').click(function(){
      $('.popout-nav-container').removeClass('open')
    });

    $('.question').click(function(){
      $(this).siblings('.answer').toggleClass('active');
      $(this).find('.fa-plus').toggleClass('closed');
      $(this).find('.fa-minus').toggleClass('opened');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js